import {
  IGetFormSchemaRequest,
  IGetFormSchemaResponse
} from "../../modules/EmployeeTaxForms/types";
import { requestForms } from "../serviceForms";

// `:formInstanceId` already identifies the pair server-side — the engine
// resolves payee/payer from the row itself, no engagement id needed.
export const getSchema = async (
  request: IGetFormSchemaRequest
): Promise<IGetFormSchemaResponse> => {
  const { formInstanceId, values } = request;
  // Re-evaluation answers ride a POST body, never query strings — tax answers
  // must not land in access logs.
  if (values) {
    return requestForms<IGetFormSchemaResponse>({
      method: "POST",
      path: `/${formInstanceId}/schema/evaluate`,
      body: { values }
    });
  }
  return requestForms<IGetFormSchemaResponse>({
    method: "GET",
    path: `/${formInstanceId}/schema`
  });
};
